// src/theme/typography.js
export const getTypography = (theme) => ({
  fontFamily: 'Lato, sans-serif',

  display: {
    fontSize: '40px',
    fontWeight: 400,
    lineHeight: '60px',
    fontStyle: 'normal',
    display: 'block',
    color: theme.palette.text.primary,
    [theme.breakpoints.down('md')]: {
      fontSize: '24px',
      lineHeight: '32px',
    },
  },
  title: {
    fontSize: '32px',
    fontWeight: 600,
    lineHeight: '40px',
    fontStyle: 'normal',
    display: 'block',
    color: theme.palette.text.primary,
    [theme.breakpoints.down('md')]: {
      fontSize: '24px',
      lineHeight: '30px',
    },
  },

  h1: {
    fontSize: '24px',
    fontWeight: 600,
    lineHeight: '40px',
    fontStyle: 'normal',
    display: 'block',
    color: theme.palette.text.primary,
    [theme.breakpoints.down('md')]: {
      fontSize: '20px',
      lineHeight: '32px',
    },
  },

  // Heading/medium
  h2: {
    fontSize: '20px',
    fontWeight: 600,
		fontStyle: 'normal',
    lineHeight: '32px',
    display: 'block',
    color: theme.palette.text.primary,
    [theme.breakpoints.down('md')]: {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: 700,
    },
  },

 // Heading/small
  h3: {
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: '24px',
    fontStyle: 'normal',
    display: 'block',
    color: theme.palette.text.primary,
    [theme.breakpoints.down('md')]: {
      fontSize: '13px',
      lineHeight: '20px',
    },
  },

  // label/medium
  labelM: {
    fontSize: '13px',
    fontWeight: 700,
    lineHeight: '20px',
    fontStyle: 'normal',
    display: 'block',
    color: theme.palette.text.primary,
    [theme.breakpoints.down('md')]: {
      fontSize: '11px',
      lineHeight: '20px',
    },
  },



  labelK: {
    fontSize: '14px',
    fontWeight: 600,
    fontStyle: 'normal',
    lineHeight: '20px',
    display: 'block',
    color: theme.palette.text.primary,
  },

  // label/small
  labelS: {
    fontSize: '13px',
    fontWeight: 700,
    lineHeight: '20px',
    fontStyle: 'normal',
    display: 'block',
    color: theme.palette.text.primary,
    [theme.breakpoints.down('md')]: {
      fontSize: '11px',
      lineHeight: '20px',
      fontWeight: 700,
    },
  },
  
  // label/Default
  labelD: {
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
    fontStyle: 'normal',
    display: 'block',
    color: theme.palette.text.primary,
    [theme.breakpoints.down('md')]: {
      fontSize: '13px',
      lineHeight: '20px',
      fontWeight: 700,
    },
  },

  labelF: {
    fontSize: '12px',
    fontWeight: 600,
    fontStyle: 'normal',
    lineHeight: '18px',
    display: 'block',
    color: theme.palette.text.primary,
  },
  // Body/default
  body1: {
    fontSize: '16px',
    fontWeight: 400,
    fontStyle: 'normal',
    lineHeight: '24px',
    display: 'block',
    color: theme.palette.text.primary,
    [theme.breakpoints.down('md')]: {
      fontSize: '13px',
      lineHeight: '20px',
    },
  },
  
  bodyL: {
    fontSize: '16px',
    fontWeight: 600,
    fontStyle: 'normal',
    lineHeight: '24px',
    display: 'block',
    color: theme.palette.text.primary,
    [theme.breakpoints.down('md')]: {
      fontSize: '13px',
      lineHeight: '20px',
    },
  },
  bodyM: {
    fontSize: '13px',
    fontWeight: 600,
    fontStyle: 'normal',
    lineHeight: '24px',
    display: 'block',
    color: theme.palette.text.primary,
    [theme.breakpoints.down('md')]: {
      fontSize: '11px',
      lineHeight: '20px',
    },
  },
  
  p1: {
    fontSize: '16px',
    fontWeight: 400,
    fontStyle: 'normal',
    lineHeight: '24px',
    display: 'block',
    color: theme.palette.text.primary,
    [theme.breakpoints.down('md')]: {
      fontSize: '13px',
      lineHeight: '20px',
    },
  },

  p2: {
    fontSize: '14px',
    fontWeight: 600,
    fontStyle: 'normal',
    lineHeight: '20px',
    display: 'block',
    color: theme.palette.text.primary,
  },
  
  // Body/medium
  p3: {
    fontSize: '13px',
    fontWeight: 400,
    fontStyle: 'normal',
    lineHeight: '20px',
    display: 'block',
    color: theme.palette.text.primary,
    [theme.breakpoints.down('md')]: {
      fontSize: '11px',
      lineHeight: '20px',
    },
  },

  p4: {
    fontSize: '12px',
    fontWeight: 400,
    fontStyle: 'normal',
    lineHeight: '18px',
    display: 'block',
    color: theme.palette.text.primary,
  },

  caption: {
    fontSize: '12px',
    fontWeight: 400,
    fontStyle: 'normal',
    lineHeight: '16px',
    display: 'block',
    color: theme.palette.text.primary,
  },

  overline: {
    fontSize: '11px',
    fontWeight: 600,
    fontStyle: 'normal',
    letterSpacing: '0.5px',
    lineHeight: '16px',
    textTransform: 'uppercase',
    display: 'block',
    color: theme.palette.text.primary,
  },
});
